/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';

interface ActionIntegrationCardLinkArgs {
  cardType: string;
  routeName: string;
  onClick(evt: MouseEvent): void;
  dynamicSegment?: string;
  external?: boolean;
  featureGated?: boolean;
  target?: string;
}

export default class ActionIntegrationCardLink extends Component<ActionIntegrationCardLinkArgs> {
  @service account!: AccountService;

  get isEssentialsTrial() {
    return this.account.current.suspendTrialAt != null;
  }
}
